module.exports = __webpack_public_path__ + "img/slide_gag.6dbb055f.svg";